import { render, staticRenderFns } from "./locked.vue?vue&type=template&id=1fe5bb90&scoped=true&"
import script from "./locked.js?vue&type=script&lang=js&"
export * from "./locked.js?vue&type=script&lang=js&"
import style0 from "./locked.scss?vue&type=style&index=0&id=1fe5bb90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe5bb90",
  null
  
)

export default component.exports